import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Loading from "../general/Loading";
import DataTable from "react-data-table-component";
import { Toast,ToastContainer } from "react-bootstrap";
import FormNuevaCita from "./FormNuevaCita";
import { getElementosHora, convertirHoraMilitarA12h, ordenarCitasPorFechaHoraAsc } from "../../../resources/Helper";
import { saveAgendaFocusAndNavigate } from "../../../resources/agendaFocusNavigation";

const estiloCeldaHover = {
    display: 'inline-block',
    maxWidth: '280px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    verticalAlign: 'bottom',
};

function celdaConHover(valor) {
    const t = valor != null && valor !== '' ? String(valor) : '';
    return <span title={t || undefined} style={estiloCeldaHover}>{t || '—'}</span>;
}

function esBloqueo(item) {
    return item?.bloqueo !== undefined && item?.bloqueo !== null && String(item.bloqueo).trim() !== '';
}

function getBloqueoId(item) {
    if (!esBloqueo(item)) return null;
    const n = parseInt(String(item.bloqueo), 10);
    return Number.isNaN(n) ? null : n;
}

const opcionesPaginacionES = {
    rowsPerPageText: 'Filas por página',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todas',
};

const estilosTabla = {
    headCells: {
        style: { fontSize: '13px', fontWeight: 600 },
    },
    cells: {
        style: { fontSize: '13px' },
    },
};

const FALLBACK_COLOR_ESTADO_SMILE = {
    0: "#12B8B8",
    1: "#FFCD00",
    2: "#7ECC38",
    3: "#F12B38",
    4: "#808080",
    5: "#00CDF8",
    6: "#BE61FC",
    7: "#ADFF2F"
};


function BusquedaCitas() {

    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus,setModalContainerStatus] = useState('');
    const [modalBackdropStatus,setModalBackdropStatus] = useState('zindex-back');
    const [estadosCita, setEstadosCita] = useState([]);
    const [profesionales, setProfesionales] = useState([]);
    const [agendas, setAgendas] = useState([]);
    const [unidades, setUnidades] = useState([]);

    const [terminoBusqueda, setTerminoBusqueda] = useState();
    const [estadoCita, setEstadoCita] = useState();
    const [fechaInicial, setFechaInicial] = useState();
    const [fechaFinal, setFechaFinal] = useState();
    const [profesional, setProfesional] = useState();
    const [unidad, setUnidad] = useState();

    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);


    //////////////////////////

    const [modalState, setModalState] = useState('hidden');
    const [verCitaModalState, setVerCitaModalState] = useState('hidden');

    const [profesionalAsignado, setProfesionalAsignado] = useState();
    //const [nombreProfesionalAsignado, setNombreProfesionalAsignado] = useState();
    const [usuarioAsigna, setUsuarioAsigna] = useState();
    const [nombreUsuarioAsigna, setNombreUsuarioAsigna] = useState();
    const [primerNombre, setPrimerNombre] = useState();
    const [segundoNombre, setSegundoNombre] = useState();
    const [primerApellido, setPrimerApellido] = useState();
    const [segundoApellido, setSegundoApellido] = useState();
    const [email, setEmail] = useState();
    const [celular, setCelular] = useState();
    const [tipoDocumento, setTipoDocumento] = useState();
    const [numeroDocumento, setNumeroDocumento] = useState();
    const [idPaciente, setIdPaciente] = useState();
    const [idCita, setIdCita] = useState();

    const [fechaCita, setFechaCita] = useState('');
    const [horaCita, setHoraCita] = useState('');
    const [duracion, setDuracion] = useState('');
    const [estado, setEstado] = useState('');
    const [horaAtencionCita, setHoraAtencionCita] = useState('');
    const [minutoCita, setMinutoCita] = useState('');
    const [ampmCita, setAmpmCita] = useState('');
    const [unidadAtencion, setUnidadAtencion] = useState('');
    const [idConvenios, setIdConvenios] = useState('');
    const [motivoConsulta, setMotivoConsulta] = useState('');

    //////////////////////////

    let userdata = [];
    let clientData = [];

    const cols = [
        { name: 'Paciente', cell: (row) => celdaConHover(getNombre(row)), sortable: true },
        { name: 'Fecha', selector: (row) => row.fecha_cita, sortable: false, cell: (row) => celdaConHover(row.fecha_cita) },
        { name: 'Hora', selector: (row) => convertirHoraMilitarA12h(row.hora_cita), sortable: false, cell: (row) => celdaConHover(convertirHoraMilitarA12h(row.hora_cita)) },
        { name: 'Duración', selector: (row) => row.duracion_cita, sortable: false, cell: (row) => celdaConHover(row.duracion_cita) },
        { name: 'Estado', sortable: false, cell: (row) => getEstado(row) },
        { name: 'Celular', sortable: false, cell: (row) => celdaConHover(row.celular) },
        { name: 'Agenda', sortable: false, cell: (row) => celdaConHover(row.agenda_nombre) },
        { name: 'Acciones', cell: (row) => getBotones(row), minWidth: '140px' },
    ];

    const irAAgendaDesdeFila = (e, item) => {
        e.preventDefault();
        e.stopPropagation();
        if (!item.id_users || !item.fecha_cita) return;
        saveAgendaFocusAndNavigate(history, {
            agendaId: item.id_users,
            agendaNombre: item.agenda_nombre,
            fechaCita: item.fecha_cita,
            horaCita: item.hora_cita,
            citaId: item.id,
        });
    };

    const getBotones = (item) => {
        const bloqueo = esBloqueo(item);
        const puedeReagendar = puedeReagendarCita(item);
        return (
            <div className="d-flex flex-wrap align-items-center" style={{ gap: '6px' }}>
                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={(e) => irAAgendaDesdeFila(e, item)} title="Ir a agenda" aria-label="Ir a agenda">
                    <i className="far fa-calendar-alt" aria-hidden="true" />
                </button>
                {bloqueo ? (
                    <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => eliminarBloqueo(item)} title="Eliminar bloqueo" aria-label="Eliminar bloqueo">
                        <i className="fas fa-trash-alt" aria-hidden="true" />
                    </button>
                ) : puedeReagendar ? (
                    <button type="button" className="btn btn-primary btn-sm" onClick={(e) => reagendarCita(e, item)} title="Reagendar" aria-label="Reagendar">
                        <i className="far fa-calendar-plus" aria-hidden="true" />
                    </button>
                ) : (
                    <button type="button" className="btn btn-primary btn-sm" onClick={(e) => verCita(e, item)} title="Editar" aria-label="Editar">
                        <i className="far fa-edit" aria-hidden="true" />
                    </button>
                )}
            </div>
        );
    };

    const getEstadoConfig = (item) => {
        if (!item || item.id_estado_cita == null) return null;
        return estadosCita.find((ec) => String(ec.id) === String(item.id_estado_cita)) || null;
    };

    const getColorEstado = (item) => {
        if (esBloqueo(item)) return "#6c757d";
        const estado = getEstadoConfig(item);
        const colorEstado = estado?.color != null ? String(estado.color).trim() : '';
        if (colorEstado) return colorEstado;
        const colorItem = item?.estado_color != null ? String(item.estado_color).trim() : (item?.color != null ? String(item.color).trim() : '');
        if (colorItem) return colorItem;
        const smRaw = estado?.estado_smile;
        if (smRaw !== undefined && smRaw !== null && smRaw !== '') {
            const sm = parseInt(String(smRaw), 10);
            if (!Number.isNaN(sm) && FALLBACK_COLOR_ESTADO_SMILE[sm]) {
                return FALLBACK_COLOR_ESTADO_SMILE[sm];
            }
        }
        return "#6c757d";
    };

    const getEstiloBadgeEstado = (item) => {
        const color = getColorEstado(item);
        return {
            backgroundColor: `${color}22`,
            color: "#2d3742",
            border: `1px solid ${color}88`,
            borderRadius: "999px",
            fontWeight: 700,
            fontSize: "0.74rem",
            padding: "0.25rem 0.65rem",
            display: "inline-block",
            whiteSpace: "nowrap"
        };
    };

    const puedeReagendarCita = (item) => {
        if (esBloqueo(item)) return false;
        const estado = getEstadoConfig(item);
        const ocultarAgenda = estado?.ocultar_agenda;
        if (String(ocultarAgenda) === '1') return true;
        return String(item?.estado_cita || '').toLowerCase() === 'cancelada';
    };

    function getEstado(item) {
        if (esBloqueo(item)) {
            return <span style={getEstiloBadgeEstado(item)}>Bloqueo</span>;
        }
        return <span style={getEstiloBadgeEstado(item)}>{item.estado_cita || 'Sin estado'}</span>;
    }


    function reagendarCita(e,item) {
        e.preventDefault();
        e.stopPropagation();

        setPrimerNombre(item.primer_nombre);
        setSegundoNombre(item.segundo_nombre);
        setPrimerApellido(item.primer_apellido);
        setSegundoApellido(item.segundo_apellido);
        setEmail(item.cita_email || item.email || '');
        setCelular(item.cita_celular || item.cita_telefono || item.celular || '');
        setTipoDocumento(item.tipo_documento);
        setNumeroDocumento(item.numero_documento);
        setIdPaciente(item.id_paciente);
        setIdCita(item.id);
        setProfesionalAsignado(item.id_users);
        setMotivoConsulta(getMotivoConsultaTexto(item));

        setModalState('visible');
    }

    const getNombre = (item) => {
        if (esBloqueo(item)) {
            return 'Bloqueo de agenda';
        }
        const sn = item.segundo_nombre ? ' ' + item.segundo_nombre : '';
        const sa = item.segundo_apellido ? ' ' + item.segundo_apellido : '';
        const nombre = `${item.primer_nombre || ''}${sn} ${item.primer_apellido || ''}${sa}`.replace(/\s+/g, ' ').trim();
        return nombre || (item.cita_paciente || '—');
    };

    const getMotivoConsultaTexto = (item) => {
        if (esBloqueo(item)) {
            return item.descripcion_cita || '';
        }
        return item.motivo_consulta || item.descripcion_cita || '';
    };

    const itemsOrdenados = useMemo(() => ordenarCitasPorFechaHoraAsc(items), [items]);

    const filasParaExportar = () =>
        itemsOrdenados.map((item) => ({
            paciente: getNombre(item),
            fecha: item.fecha_cita || '',
            hora: convertirHoraMilitarA12h(item.hora_cita) || '',
            duracion: item.duracion_cita || '',
            estado: esBloqueo(item) ? 'Bloqueo' : (item.estado_cita || ''),
            celular: item.cita_celular || item.cita_telefono || item.celular || '',
            agenda: item.agenda_nombre || '',
            motivo_consulta: getMotivoConsultaTexto(item),
        }));

    const escHtml = (s) =>
        String(s ?? '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');

    const imprimirListado = () => {
        if (!itemsOrdenados.length) {
            alert('No hay citas para imprimir');
            return;
        }
        const filas = filasParaExportar();
        const filasHtml = filas
            .map(
                (f) =>
                    `<tr>
                        <td>${escHtml(f.paciente)}</td>
                        <td>${escHtml(f.fecha)}</td>
                        <td>${escHtml(f.hora)}</td>
                        <td>${escHtml(f.duracion)}</td>
                        <td>${escHtml(f.estado)}</td>
                        <td>${escHtml(f.celular)}</td>
                        <td>${escHtml(f.agenda)}</td>
                        <td>${escHtml(f.motivo_consulta)}</td>
                    </tr>`
            )
            .join('');
        const html = `<!DOCTYPE html>
<html><head><meta charset="utf-8"><title>Búsqueda de citas</title>
<style>
body{font-family:Arial,sans-serif;font-size:12px;padding:16px;}
h1{font-size:18px;margin-bottom:8px;}
table{width:100%;border-collapse:collapse;}
th,td{border:1px solid #ccc;padding:6px;text-align:left;vertical-align:top;}
th{background:#f0f0f0;}
@media print{.no-print{display:none;}}
</style></head><body>
<h1>Búsqueda de citas</h1>
<p>Total: ${filas.length} registro(s)</p>
<table>
<thead><tr>
<th>Paciente</th><th>Fecha</th><th>Hora</th><th>Duración</th><th>Estado</th><th>Celular</th><th>Agenda</th><th>Motivo de consulta</th>
</tr></thead>
<tbody>${filasHtml}</tbody>
</table>
<div class="no-print" style="margin-top:16px;">
<button onclick="window.print()">Imprimir</button>
<button onclick="window.close()">Cerrar</button>
</div>
</body></html>`;
        const ventana = window.open('', '_blank');
        if (!ventana) {
            alert('Permita ventanas emergentes para imprimir');
            return;
        }
        ventana.document.write(html);
        ventana.document.close();
    };

    const exportarExcel = () => {
        if (!itemsOrdenados.length) {
            alert('No hay citas para exportar');
            return;
        }
        import('xlsx')
            .then((XLSX) => {
                const datosExcel = filasParaExportar().map((f) => ({
                    Paciente: f.paciente,
                    Fecha: f.fecha,
                    Hora: f.hora,
                    Duración: f.duracion,
                    Estado: f.estado,
                    Celular: f.celular,
                    Agenda: f.agenda,
                    'Motivo de consulta': f.motivo_consulta,
                }));
                const ws = XLSX.utils.json_to_sheet(datosExcel);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Citas');
                const fecha = new Date().toISOString().split('T')[0];
                XLSX.writeFile(wb, `busqueda_citas_${fecha}.xlsx`);
            })
            .catch((err) => {
                console.error(err);
                alert('No se pudo exportar a Excel');
            });
    };

    const eliminarBloqueo = async (item) => {
        const bloqueoId = getBloqueoId(item);
        if (!bloqueoId) return;
        const confirmar = window.confirm('¿Deseas eliminar este bloqueo?');
        if (!confirmar) return;

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }
        if (!userdata?.access_token) return;

        const conf = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: bloqueoId
            }
        };

        try {
            await axios.delete('/bloqueo', conf);
            setToastMsg('Bloqueo eliminado');
            setShowToast(true);
            recargarCitas();
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }
        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });

        axios.get('/estados-cita?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setEstadosCita(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('profesionales?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setProfesionales(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            })

        axios.get('/agendas-usuario', config)
            .then(response => {
                if (response.status === 200) {
                    setAgendas(Array.isArray(response.data) ? response.data : []);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('unidades-atencion?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUnidades(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            })
    },[]);




    useEffect(() => {

        recargarCitas();
    },[terminoBusqueda,estadoCita,fechaInicial,fechaFinal,profesional,unidad]);


    function recargarCitas() {

        setItems([]);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                nombre: terminoBusqueda,
                estado_cita: estadoCita,
                fecha_inicio: fechaInicial,
                fecha_fin: fechaFinal,
                profesional: profesional,
                unidad: unidad
            }
        }

        axios.get('/busqueda-citas',config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.log(error.response.data);
            })
    }


    function handleCitaReagendada() {

        setToastMsg('La cita ha sido reagendada');
        recargarCitas();
    }


    function handleCitaModificada() {
        setToastMsg('La cita ha sido modificada');
        recargarCitas();
    }


    const verCita = (e, cita) => {
        e.preventDefault();

        setPrimerNombre(cita.primer_nombre);
        setSegundoNombre(cita.segundo_nombre);
        setPrimerApellido(cita.primer_apellido);
        setSegundoApellido(cita.segundo_apellido);
        setEmail(cita.cita_email || cita.email || '');
        setCelular(cita.cita_celular || cita.cita_telefono || cita.celular || '');
        setTipoDocumento(cita.tipo_documento);
        setNumeroDocumento(cita.numero_documento);
        setIdPaciente(cita.id_paciente);
        setIdCita(cita.id);
        setProfesionalAsignado(cita.id_users);
        setMotivoConsulta(getMotivoConsultaTexto(cita));

        setFechaCita(cita.fecha_cita);
        setHoraCita(cita.hora_cita);
        setDuracion(cita.duracion_cita);
        setEstado(cita.id_estado_cita);

        const fechaISO = new Date(cita.fecha_cita);

        setHoraAtencionCita(getElementosHora(cita.hora_cita)[0]);
        setMinutoCita(getElementosHora(cita.hora_cita)[1]);
        setAmpmCita(getElementosHora(cita.hora_cita)[2]);
        setUnidadAtencion(cita.id_unidad_atencion);
        setIdConvenios(cita.id_convenios != null && cita.id_convenios !== '' ? String(cita.id_convenios) : '');

        setVerCitaModalState('visible');
    }



    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/estadisticas">Reportes</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/reportes-agenda">Reportes de Agenda</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Reporte de Citas</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Reporte de Citas</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                        <div className="row" style={{marginBottom: '30px'}}>
                             
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="terminoBusqueda">Nombre/apellidos paciente</label>
                                    <input type="text" name="terminoBusqueda" className="form-control" id="terminoBusqueda" onChange={(e) => setTerminoBusqueda(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="profesional">Agenda</label>
                                    <select name="profesional" id="profesional" className="form-control" onChange={(e) => setProfesional(e.target.value)}>
                                        <option></option>
                                        {
                                            agendas.map((agenda) => 
                                                <option key={agenda.id} value={agenda.id}>{agenda.nombre}</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="estadoCita">Estado de la cita</label>
                                    <select name="estadoCita" id="estadoCita" className="form-control" onChange={(e) => setEstadoCita(e.target.value)}>
                                        <option></option>
                                        {
                                            estadosCita.map((ec) => 
                                                <option key={ec.id} value={ec.id}>{ec.nombre}</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="unidad">Unidad de atención</label>
                                    <select name="unidad" id="unidad" className="form-control" onChange={(e) => setUnidad(e.target.value)}>
                                        <option></option>
                                        {
                                            unidades.map((uni) => 
                                                <option key={uni.id} value={uni.id}>{uni.nombre_unidad}</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="fechaInicial">Fecha inicial</label>
                                    <input type="date" name="fechaInicial" className="form-control" id="fechaInicial" onChange={(e) => setFechaInicial(e.target.value)} />
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label htmlFor="fechaFinal">Fecha final</label>
                                    <input type="date" name="fechaFinal" className="form-control" id="fechaFinal" onChange={(e) => setFechaFinal(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-md-12 d-flex flex-wrap align-items-center" style={{ gap: '8px' }}>
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm"
                                    onClick={imprimirListado}
                                    disabled={!itemsOrdenados.length}
                                    title="Imprimir listado"
                                >
                                    <i className="fas fa-print mr-1" aria-hidden="true"></i>
                                    Imprimir
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-success btn-sm"
                                    onClick={exportarExcel}
                                    disabled={!itemsOrdenados.length}
                                    title="Exportar a Excel"
                                >
                                    <i className="fas fa-file-excel mr-1" aria-hidden="true"></i>
                                    Exportar Excel
                                </button>
                                <span className="text-muted small ml-1">
                                    {itemsOrdenados.length} cita(s) en el resultado
                                </span>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                
                                <DataTable
                                columns={cols}
                                data={itemsOrdenados}
                                pagination
                                highlightOnHover
                                customStyles={estilosTabla}
                                paginationComponentOptions={opcionesPaginacionES}
                                noDataComponent={<div className="p-4 text-center text-muted">No hay citas que mostrar</div>}
                                id={'citas'}
                                />

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>


                
                <div className={'modal-backdrop fade '+modalBackdropStatus}></div>

                <ToastContainer className="toast-exito">
                    <Toast onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
                        <Toast.Body>{toastMsg}</Toast.Body>
                    </Toast>
                </ToastContainer>



                <FormNuevaCita 
                            modalState={modalState} 
                            closeModal={modalState => setModalState('hidden')} 
                            profesionalAsignado={profesionalAsignado}
                            nombreUsuarioAsigna={nombreUsuarioAsigna}
                            primerNombre={primerNombre}
                            segundoNombre={segundoNombre}
                            primerApellido={primerApellido}
                            segundoApellido={segundoApellido}
                            email={email}
                            celular={celular}
                            tipoDocumento={tipoDocumento}
                            numeroDocumento={numeroDocumento}
                            verCita={false}
                            puedeAtender={false}
                            idPaciente={idPaciente}
                            primeraVez={true}
                            idCita={idCita}
                            reloadCitasAgenda={handleCitaReagendada}
                            motivoConsulta={motivoConsulta}
                            stepCita={'20'}
                />


                <FormNuevaCita
                                modalState={verCitaModalState} 
                                closeModal={() => setVerCitaModalState('hidden')} 
                                profesionalAsignado={profesionalAsignado}
                                nombreUsuarioAsigna={nombreUsuarioAsigna}
                                primerNombre={primerNombre}
                                segundoNombre={segundoNombre}
                                primerApellido={primerApellido}
                                segundoApellido={segundoApellido}
                                email={email}
                                celular={celular}
                                tipoDocumento={tipoDocumento}
                                numeroDocumento={numeroDocumento}
                                verCita={true}
                                puedeAtender={true}
                                idPaciente={idPaciente}
                                primeraVez={true}
                                idCita={idCita}
                                reloadCitasAgenda={handleCitaModificada}
                                stepCita={'20'}
                                fecha={fechaCita}
                                hora={horaCita}
                                duracionCita={duracion}
                                estadoCita={estado}
                                horaAtencionCita={horaAtencionCita}
                                minutoCita={minutoCita}
                                ampmCita={ampmCita}
                                unidadAtencion={unidadAtencion}
                                idConvenios={idConvenios}
                                motivoConsulta={motivoConsulta}

                />
                
                <Footer showToast={false} delay={0} message={toastMsg} />

            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default BusquedaCitas;